import React, { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { File } from "../../form-inputs/inputs";

const UploadIcon = (props) => {
    const triggerUpload = () => {
        document.getElementById(`file_${props.id}`).click();
    };

    const uploadFile = async () => {
        const file = document.getElementById(`file_${props.id}`).files[0];
        const success = await props.uploadFile(file);

        if (!success) {
            document.getElementById(`file_${props.id}`).value = "";
        }
    };

    return (
        <Fragment>
            <button className="button" onClick={triggerUpload} disabled={props.disabled}>
                <FontAwesomeIcon icon={faUpload} title="Upload" />
            </button>
            <div className="hide">
                <File name={`file_${props.id}`} onChange={uploadFile} accept=".jpg,.jpeg,.png" />
            </div>
        </Fragment>
    );
};

export default UploadIcon;
